import {listNhomThuoc, listTTPhieuKho} from "data/list";
import {formatToCurrencyTypeToFixed} from "helper/common";
import moment from "moment";
import React from "react";
import {FIELD_TYPE, FORMAT_TIME} from "types/enums";
import {ColumnProps} from "types/models";
import {ColumnsEdit} from "types/models/column-table-edit";
const {INPUT, CURRENCY, DATE, NUMBER, COMBO_BOX, AUTO_COMPLETE} = FIELD_TYPE;
const inputFields: any[] = [
  {
    type: INPUT,
    label: "Mã phiếu",
    name: "id",
    disable: true,
  },
  {
    type: INPUT,
    label: "Tiêu đề phiếu",
    name: "tieuDe",
  },
  {
    type: DATE,
    label: "Ngày hóa đơn",
    name: "ngayHoaDon",
    disableDate: false,
  },
  {
    type: INPUT,
    label: "Số hóa đơn",
    name: "soHoaDon",
  },
  {
    type: COMBO_BOX,
    label: "Kho nhập/đề nghị",
    name: "khoNhapId",
    rules: [{required: true, message: "Chưa chọn kho nhập/đề nghị"}],
  },
  {
    type: COMBO_BOX,
    label: "Tình trạng phiếu",
    name: "tinhTrang",
    options: listTTPhieuKho,
    disable: true,
  },
  {
    type: COMBO_BOX,
    label: "Kho xuất/cấp",
    name: "khoXuatId",
    rules: [{required: true, message: "Chưa chọn kho xuất/cấp"}],
  },
  {
    type: COMBO_BOX,
    label: "Nhà cung cấp",
    name: "nhaCungCapId",
  },

  {
    type: INPUT,
    label: "Người lập phiếu",
    name: "nguoiLap",
    value: localStorage.getItem("fullName"),
    rules: [{required: true, message: "Chưa nhập người lập phiếu"}],
  },
  {
    type: INPUT,
    label: "Người giao",
    name: "nguoiGiao",
  },
  {
    type: INPUT,
    label: "Người nhận",
    name: "nguoiNhan",
  },
  {
    type: DATE,
    label: "Ngày dự trù",
    name: "ngayDuTru",
    disableDate: false,
  },
  {
    type: DATE,
    label: "Thời điểm hoàn thành",
    name: "ngayHoanThanh",
    disableDate: false,
  },
  {
    type: CURRENCY,
    label: "Tổng giá trị",
    name: "tongGiaTri",
    disabled: true,
    formatter: value => formatToCurrencyTypeToFixed(value, 4),
  },
  {
    type: INPUT,
    label: "Ghi chú",
    name: "ghiChu",
  },
];
const columns: any[] = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    render: (text, record, index) => index + 1,
    width: 80,
    show: true,
    align: "center",
  },
  {
    title: "",
    dataIndex: "id",
    key: "id",
    type: INPUT,
    show: true,
    width: 0,
  },

  {
    type: AUTO_COMPLETE,
    dataIndex: "soLo",
    key: "soLo",
    title: "Số lô",
    show: true,
    align: "left",
    width: 250,
  },
  {
    type: NUMBER,
    title: "Số lượng tồn",
    dataIndex: "tonKho",
    disabled: true,
    align: "right",
    show: true,
  },
  {
    type: AUTO_COMPLETE,
    dataIndex: "tenThuoc",
    key: "tenThuoc",
    title: "Tên thuốc",
    show: true,
    width: 200,
    autoFocus: true,
  },
  {
    type: INPUT,
    dataIndex: "soLoNCC",
    key: "soLoNCC",
    title: "Số lô nhà cung cấp",
    align: "left",
    show: true,
  },
  {
    type: DATE,
    dataIndex: "ngayHetHan",
    key: "ngayHetHan",
    title: "Ngày hết hạn",
    align: "center",
    show: true,
    width: 150,
  },
  {
    type: COMBO_BOX,
    dataIndex: "donViTinhId",
    key: "donViTinhId",
    title: "Đơn vị tính",
    show: true,
    width: 120,
  },

  {
    type: NUMBER,
    dataIndex: "soLuongNhap",
    key: "soLuongNhap",
    title: "Số lượng nhập",
    align: "right",
    show: true,
    width: 100,
    // disabled: false,
  },
  {
    type: NUMBER,
    dataIndex: "soLuongNhap",
    key: "soLuongNhap",
    title: "Số lượng xuất",
    align: "right",
    show: true,
    width: 100,
  },
  {
    type: NUMBER,
    dataIndex: "soLuongNhap",
    key: "soLuongNhap",
    title: "Số lượng dự trù",
    align: "right",
    show: true,
    width: 100,
  },
  {
    type: CURRENCY,
    dataIndex: "donGiaNhap",
    key: "donGiaNhap",
    title: "Đơn giá nhập",
    align: "right",
    show: true,
    width: 180,
    // disabled: false,
  },
  {
    type: CURRENCY,
    dataIndex: "thanhTien",
    key: "thanhTien",
    title: "Thành tiền (Trước VAT)",
    show: true,
    align: "right",
    disabled: true,
    width: 200,
  },
  {
    type: NUMBER,
    dataIndex: "vat",
    key: "vat",
    title: "VAT",
    align: "right",
    show: true,
    width: 80,
  },
  {
    type: CURRENCY,
    dataIndex: "tongTien",
    key: "tongTien",
    title: "Thành tiền (Sau VAT)",
    show: true,
    align: "right",
    disabled: true,
    width: 200,
  },

  {
    type: CURRENCY,
    dataIndex: "donGiaXuat",
    key: "donGiaXuat",
    title: "Đơn giá bán",
    show: true,
    // disabled: false,
  },
  {
    type: AUTO_COMPLETE,
    dataIndex: "decision",
    key: "decision",
    title: "Quyết định thầu",
    show: true,
  },
  {
    type: INPUT,
    dataIndex: "ghiChuThau",
    key: "ghiChuThau",
    title: "Ghi chú thầu",
    show: true,
  },
  {
    type: DATE,
    dataIndex: "createDate",
    key: "createDate",
    title: "Ngày nhập",
    align: "center",
    show: true,
  },
  {
    type: AUTO_COMPLETE,
    dataIndex: "thuocId",
    key: "thuocId",
    title: "Mã sản phẩm",
    align: "center",
    show: true,
    // autoFocus: true,
    disabled: true,
  },
  {
    type: COMBO_BOX,
    dataIndex: "duocChinhId",
    key: "duocChinhId",
    title: "Dược chính",

    show: true,
  },
  {
    type: COMBO_BOX,
    dataIndex: "baoCheId",
    key: "baoCheId",
    title: "Dạng bào chế",
    show: true,
  },
  {
    type: INPUT,
    dataIndex: "hoatChat",
    key: "hoatChat",
    title: "Hoạt chất",
    show: true,
  },

  // {
  //   type: INPUT,
  //   dataIndex: "baoQuan",
  //   key: "baoQuan",
  //   title: "Điều kiện bảo quản",
  //   show: true,
  // },

  {
    type: INPUT,
    dataIndex: "ghiChu",
    key: "ghiChu",
    title: "Ghi chú",
    show: true,
    autoFocus: false,
  },
  {
    title: "",
    dataIndex: "",
    key: "action",
    align: "center",
    width: 60,
    fixed: "right" as any,
    show: true,
  },
];
export {inputFields, columns};
